
export enum AwardedUnitsDisplayType {
    CurrencyValue = 0,
    UnitValue = 1,
}